import { ReactNode } from 'react';
import startLogo from 'src/assets/icons/start_logo.png';
import { COMPLIMIND_LOGO_URL } from 'src/constants/branding';
import TrustedByCarousel from 'src/components/ui/TrustedByCarousel';

interface FrontLayoutProps {
  children: ReactNode;
  showTrustedBy?: boolean;
  complimind?: boolean;
  iheem?: boolean;
}

export default function FrontLayout({
  children,
  showTrustedBy = false,
  complimind = true,
  iheem = false
}: FrontLayoutProps) {
  return (
    <div className="grid min-h-screen grid-rows-[minmax(min-content,1fr)_auto_minmax(min-content,1fr)] justify-items-center bg-navbar p-3 sm:px-0">
      <div className="flex items-end justify-center py-8">
        <div className="flex flex-row items-center justify-center gap-12">
          {iheem && (
            <img
              src="https://innexpublic.blob.core.windows.net/platform-assets/organisations/iheem-big.png"
              alt="IHEEM Logo"
              width={110}
              height={110}
            />
          )}
          {!complimind && <img src={startLogo} alt="CompliMind Logo" className="w-[150px] h-auto object-contain" />}
          {complimind && (
            <img src={COMPLIMIND_LOGO_URL} alt="Complimind Logo" className="w-[150px] h-auto object-contain" />
          )}
        </div>
      </div>
      <div className="w-full max-w-[536px]">{children}</div>
      <div className="flex w-full max-w-[670px] items-start justify-center pt-8">
        {showTrustedBy && <TrustedByCarousel excludeIheem={iheem} />}
      </div>
    </div>
  );
}
